import { motion } from 'framer-motion';
import { Globe, MapPin, Clipboard, Users, FlaskConical } from 'lucide-react';

const trustItems = [
  { icon: Globe, label: 'Online en toda España' },
  { icon: MapPin, label: 'Base en Málaga' },
  { icon: Clipboard, label: 'Plan a medida' },
  { icon: Users, label: 'Seguimiento real' },
  { icon: FlaskConical, label: 'Enfoque basado en ciencia' },
];

export const TrustBar = () => {
  return (
    <section 
      className="py-8 bg-brand-primary/5 border-y border-brand-sage/20"
      data-testid="trust-bar"
    >
      <div className="section-container">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12">
          {trustItems.map((item, index) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center gap-2 text-text-secondary"
              data-testid={`trust-item-${index}`}
            >
              <item.icon className="w-5 h-5 text-brand-primary" />
              <span className="text-sm font-medium">{item.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
